/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { en, pt } from 'vuetify/locale';
// Composables
import { createVuetify } from 'vuetify';
import { vuetifyColors } from '../../theme';
import type { VAlert, VAutocomplete, VBanner, VBtn, VTextarea, VTextField } from 'vuetify/lib/components/index.mjs';
import { VFileUpload } from 'vuetify/labs/VFileUpload';

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    components: {
        VFileUpload,
    },
    defaults: {
        VTextField: {
            density: 'comfortable',
            hideDetails: 'auto',
            variant: 'plain',
            rounded: 'pill',
            bgColor: 'white',
        } as VTextField['$props'],
        VBtn: {
            elevation: 1,
        } as VBtn['$props'],
    },
    locale: {
        locale: 'pt',
        fallback: 'en',
        messages: { pt, en },
    },
    display: {
        mobileBreakpoint: 'sm',
        thresholds: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
            xxl: 1536,
        },
    },
    theme: {
        themes: {
            light: {
                colors: vuetifyColors(),
            },
        },
    },
});
